'use client';

import { useApi } from '@prismo-io/core';
import useSWRMutation from 'swr/mutation';
import { sendLeadHasClickedHubspot } from './send-lead-has-clicked-hubspot';
export const useSendLeadHasClickedHubspot = () => {
  const {
    client
  } = useApi();
  return useSWRMutation(['send-lead-has-clicked-teasing-hubspot'], key => sendLeadHasClickedHubspot(client));
};